export default {
  install(Vue, options) {
    Vue.prototype.$cookie = Vue.cookie = this
  },
  tokenCookieName: 'Uniq.ImageUploader.Token',
  create: function(name, value, days) {
    var date, expires
    if (days) {
      date = new Date()
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
      expires = '; expires=' + date.toGMTString()
    } else {
      expires = ''
    }
    document.cookie = `${name}=${value}${expires}; path=/;`
  },
  get: function(name) {
    let value = `; ${document.cookie}`
    let parts = value.split(`; ${name}=`)
    if (parts.length === 2)
      return parts
        .pop()
        .split(';')
        .shift()
  },
  delete: function(name) {
    document.cookie = `${name}=; path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT;`
  }
}
